import { render, staticRenderFns } from "./PortalRegistrationMethod.vue?vue&type=template&id=571cd820&scoped=true&"
import script from "./PortalRegistrationMethod.vue?vue&type=script&lang=js&"
export * from "./PortalRegistrationMethod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571cd820",
  null
  
)

export default component.exports